import { Component, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { PdfService } from '../pdf.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-purchase-invoice',
  templateUrl: './purchase-invoice.component.html',
  styleUrls: ['./purchase-invoice.component.scss'],
})
export class PurchaseInvoiceComponent {
  quotationObj: any;
  purrchaseItems: any;
  promotions:any=[];
  region;
  country;
  state;
  orderItems:any=[];
  city;
  dateFormat;
  id;
  showQty;
  openpop: boolean = false;
  bigpop: boolean = false;
  openEdit: boolean = false;
  recPay:boolean = false;
  editItem: any;
  img;
  frmScan: boolean = false;
  openReturn: boolean = false;
  barpop: boolean = false;
  returnItem1: any = [];
  returnItem2: any = [];
  allItems: any = [];
  returnImg;
  percent: any;
  percent1: any;
  discountPercent;
  discountAmt;
  openScanner: boolean = false;
  reasonId;
  fontStyle;
  reasonName;
  openExchange: boolean = false;
  item;
  newitem;
  url;
  header1;header2;
  returnCheck: boolean=false;
  curntItem: any = {};
  newItem: any = {};
  header;
  name;
  qty;
  ItemOrders:any=[];
  amount;
  Price;
  Quantity;
  storeObj: any = [];
  items:[];
  headLang = localStorage.getItem('lang');
  reasons: any = [{ id: 1, name: "Size didnt fit" },
  { id: 2, name: "Color didnt match" },
  { id: 3, name: "Style isnt good" },
  { id: 4, name: "Didnt like it" },
  { id: 5, name: "Damaged" }];
  paymentMode: any = [{ id: 1, name: "Cash" },
  { id: 4, name: "Cheque" },{ id: 5, name: "Google Pay" },{id: 7, name: "Phonepe"},{id: 8, name: "Paytm"}];
  paymentId;
  paymentName;
  paymentStatus: any = [{ id: 2, name: "Paid" },
  { id: 1, name: "Not Paid" }];
  paymentStatusName;
  paymentStatusId;
  amountPaid;
  adjustedAmt;
  reason;
  active: boolean = false;
  show:boolean=false;
  refNo;
  msg;
  pendingAmt;
  constructor(private service: ApiService, public pdf: PdfService,
    public router: Router, public auth: AuthService,
    private handler: HandlerService,   
    private bottomSheet: MatBottomSheet) { }


  async ionViewWillEnter() {
    this.url = window.location.href;
    this.fontStyle=localStorage.getItem('lang'); 
    this.pdf.loader = true;
    this.dateFormat = this.auth.getDateformat();
    this.id = window.location.href.split("/").pop();
    if(this.url.includes('record-pay')){
      this.recPay=true;
    }else{
      this.recPay=false;
    }
    this.service.getOrderById(this.id).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.purrchaseItems = res;
        this.ItemOrders = res.itemOrders;         
        this.orderItems = res.orderItems; 
        this.paymentId = res.paymtMode;
        this.paymentStatusId = res.paymentStatus;
        this.amountPaid=res.amountPaid;
        this.refNo=res.paymtRef; 
        this.adjustedAmt=res.adjustedPayTotal;
       this.reason=res.adjustedComments;
        this.active= res.adjusted;
        this.pendingAmt=res.balanceAmount;  
        this.paymentMode.map(res=>{        
          if(res.id == this.paymentId ){
            this.paymentName = res.name;
            this.paymentId = res.id;
          }
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId ){
            this.paymentStatusName = res.name
          }
          
        })         
        this.pdf.loader = false;     
      }
    },
      err => {
        this.pdf.loader = false;
        this.handler.err(err.error)
      })
   
  }



  pay() {  
    sessionStorage.setItem('PayCost', this.purrchaseItems.orderAmountStr)
    this.router.navigate(['/order-payment'])
  }

 
  ionViewWillLeave() {
    this.pdf.popup = false;
    this.pdf.loader = false;
    this.openEdit = false;
    let h: any = document.getElementById('hidden');
    if(h)
    h.style.visibility = "visible";
    let h1: any = document.getElementById('pop');
    if(h1)
    h1.style.visibility = "visible";
    this.openScanner = false;
    this.curntItem = undefined;
    this.newItem = undefined;
    this.item = undefined;
    this.returnItem1=[];
    this.returnItem2=[];
    this.frmScan=false;
  }
  email() {
    Object.assign(this.purrchaseItems, { header: "BILL", subheader: "BILL #:" })
    // this.pdf.generatePdf(this.purrchaseItems);
  }

  returnItems(item, id) {
    this.pdf.loader=true;
    this.curntItem = item;
     this.service.getItemById(item.id).subscribe((res:any)=>{
      if(res.img)
      Object.assign(item,{img:res.img})
      this.pdf.loader=false;
      if(id==1){
        this.openExchange = true;
      setTimeout(() => {
        document.getElementById('upc1').focus()
      }, 500);
      }
      if (id == 2){
        this.openReturn = true;
      }
    },
    err=>{
      this.pdf.loader=false;
      this.handler.err(err);
      this.openReturn=false;
      this.openExchange=false;
    })


  }


 
  openBottomSheetReason(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.reasons,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.reasonName = res.name;
      this.reasonId = res.id;
    });
  }

  getAllItems() {
    this.pdf.loader = true;
    this.barpop = false;
    this.service.getAllItems().subscribe(res => {
      this.allItems = res;
      this.bigpop = true;
      this.pdf.loader = false;

    })
  }

  recordPay(){
    var post1 ={     
      paymentRcvdBy: localStorage.getItem("currentUserId"),    
      paymentStatus:2, 
      amountPaid:this.amountPaid,
      adjustedPayTotal:this.adjustedAmt,
      adjustedComments:this.reason,
      adjusted:this.active,
      paymtAmt:this.purrchaseItems.orderAmountStr ,
      paymtMode:this.paymentId,
      paymtRef:this.refNo,
      invoiceNotes:this.msg,
    } 
    this.service.postOrderPaymentDetails(this.id,post1).subscribe((res:any)=>{
      this.handler.res("Payment Details Added SuccessFully");     
        this.router.navigate(['/manage-Order']);   
    })
  }

  openBottomSheet(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.paymentMode,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentId = res.id;
      this.paymentName = res.name;
      if(this.paymentId==4 || this.paymentId==5 || this.paymentId==7 || this.paymentId==8){
        this.show=true;
        this.refNo="";
      }else{
        this.show=false;
      }
    });
  }

  openBottomSheetStatus(){
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.paymentStatus,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.paymentStatusId = res.id;
      this.paymentStatusName = res.name;
      if(this.paymentStatusId==1){
        this.amountPaid="";
        this.refNo="";
        this.paymentId="";
        this.paymentName="";
      }else{
        this.paymentId = this.purrchaseItems.PaymtMode;
        this.paymentStatusId = this.purrchaseItems.paymentStatus;
        this.amountPaid=this.purrchaseItems.amountPaid;
        this.refNo=this.purrchaseItems.PaymtRef;
        this.paymentMode.map(res=>{
          if(res.id == this.paymentId ){
            this.paymentName = res.name
          }
        })
        this.paymentStatus.map(res=>{
          if(res.id == this.paymentStatusId ){
            this.paymentStatusName = res.name
          }
        })
      }
    });
  }

  cancel(){
    if(this.url.includes('record-pay')){
      this.router.navigate(['/manage-Order']);   
    }else{
      this.router.navigate(['/bookservice1']);     
    }
  }

//   addQuantity(data) {   
//         this.storeObj.map(res => {
//         if (res != data)
//           res.select = false;
//         else
//           res.select = true
//       })      
//         data.showQty = data.showQty + 1;
//        this.updateOrder();

// }

//   decQuantity(data) {  
//     this.storeObj.map(res => {
//       if (res != data)
//         res.select = false;
//       else
//         res.select = true
//     })
//        if (data.showQty == 0)
//         data.showQty = data.showQty;
//       else {
//         data.showQty = data.showQty - 1;
//         this.updateOrderItem()
//       }
//   }

  updateOrder(data) {  
   data.qty = 1;
    let products = {      
      "items" :[
        {
            "id" : data.itemId,
            "qty" :data.qty,
            "productId":data.itemTypeId
        }
    ],
orderType: 2,
     }
       this.service.orderItemPost(this.id, data.itemId, products).subscribe((res:any) => {
      if(res){
        // this.getOrder(this.orderId);
          this.orderItems = res;        
           this.ionViewWillEnter();
          }

    },
      err => {
              this.handler.err(err)
      })
  }

  async updateOrderItem(data){
    console.log(data)
    data.qty = data.qty-1;
    let products = {      
      "items" :[
        {
            "id" : data.itemId,
            "qty" :data.qty,
            "productId":data.itemTypeId
        }
    ],
      orderType: 2 }  
      this.service.updateOrderItem(this.id, data.itemId, products).subscribe(res => {
        if(res){
          this.orderItems = res;          
         } this.ionViewWillEnter();
      },
        err => {
               this.handler.err(err)
        })
    }

    continueShopping(){
      this.router.navigate(['/edit-purchase',this.id])
    }

}
